export default __webpack_public_path__ + "static/media/323D.a0f45bf1.jpg";